export const NotificationScreensOptions = [
    { value: 'news', label: 'News' },
    { value: 'balance_history', label: 'Balance History' },
    { value: 'games', label: 'Games' },
];